import axios from 'axios';

// Service function to get active users for statistics
export const getActiveUsersForStatistics = async (baseUrl) => {
  try {
    const response = await axios.get(`${baseUrl}/admin/getActiveUsersForStatistics`);
    
    if (response.data) {
      return {
        success: true,
        users: response.data || []
      };
    } else {
      // Mock data if the server returns an error or unexpected format
      console.warn('Server returned an error or unexpected format for users. Using mock data.');
      return getMockUsersData();
    }
  } catch (error) {
    console.error('Error fetching users data:', error);
    // Fallback to mock data
    return getMockUsersData();
  }
};

// Mock users data function
const getMockUsersData = () => {
  return {
    success: true,
    users: [
      { id: 1, name: 'John Doe', type: 'regular', active: true },
      { id: 2, name: 'Jane Smith', type: 'technical', active: true },
      { id: 3, name: 'Mike Johnson', type: 'driver', active: false },
      { id: 4, name: 'Sarah Wilson', type: 'regular', active: true },
      { id: 5, name: 'Tom Brown', type: 'technical', active: true },
      { id: 6, name: 'Lisa Davis', type: 'driver', active: false },
      { id: 7, name: 'Chris Miller', type: 'regular', active: true },
      { id: 8, name: 'Amy Taylor', type: 'technical', active: false },
    ],
    fromMock: true
  };
};

export default getActiveUsersForStatistics;
